import React                 from 'react';
import MinTraceSpaceCheckbox from 'pu-react/components/MinTraceSpaceCheckbox';

const MinTraceSpace = (props) => {
  const value = '< 4 mils'
  const name = 'min_trace_space';
  const onChange = (e) => props.onChangeParameter(name, e.target.checked ? value : null)
  return (
    <MinTraceSpaceCheckbox
      {...props}
      label="Trace & Space < 4 mils"
      tooltip={null}
      drawHidden={false}
      checked={props.parameters[name] === value}
      onChange={onChange}
      value={value} />
  );
};

export default MinTraceSpace;
